import stackReportDashboardSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";

export const stackReportDashboardActions = { ...actions, ...thunkActions };
export * as StackReportDashboardTypes from "./types";
export default stackReportDashboardSlice;
